import touchEventMixins from "../mixin/touchEventMixins";

export default {
  name: "math-answer",
  props: {
    multipleAnswers: Array,
    viewAnswer : Function,
    question: Object,
    bool: Object,
    bgColors: Object,
    currentPage: Number,
    examFlameHeight: Function,
    selectMultipleItem: Function,
    undoSelection: Function,
    clearAllSelection: Function,
    drag: Function,
    dragging: Function,
    dragstop: Function,
    checkAnswer: Function,
    disableUsedAnswers: Function,
  },
  data : function (){
    return {
      hasLongText : false,
      buttonStyle : {
        width : '0px',
        //height : '0px'
      },
      hasImage : false,
      displayTap : false
    }
  },
  mounted : function (){
    let answers = this.question.contents.answers;
    let answer = this.question.contents.answer;
    if(answers.length == 0){
      this.bool.active_next = true;
      this.displayTap = true
    }
    let ext = answer.split('.').pop();
    if(ext === 'png' || ext === 'jpg'){
      this.hasImage=true;
    }
    this.adjustButton();
  },
  mixins: [touchEventMixins],
  methods: {
    getAnswerImageSrc: function(item, currentPage) {
      return currentPage;
      
    },
    checkRepeat : function(answer){
      let ans = answer.split(":")
      if(ans.length > 1){
        return ans[0]
      }

      return answer;
    },
    adjustButton : function(){
      let answers = this.question.contents.answers;
      let arr = [];
      let w = window.innerWidth - 150;
      answers.forEach(ans => {
        if(ans.length >=4){
          arr.push(ans);
        }
      });
      if(arr.length > 0){
        this.hasLongText = true;
        w =  window.innerWidth - w; 
        this.buttonStyle.width = w+'px'
       // this.buttonStyle.height = this.examFlameHeight('answer', 0.1).height
      }
    }
  },
};
